import { Switch } from "@headlessui/react";
import { ReactNode } from "react";

import clsxm from "../../lib/clsxm";

export interface ToogleShortProps {
  label?: ReactNode;
  description?: ReactNode;
  isEnabled?: boolean;
  disabled?: boolean;
  onChange: () => void;
}

const Toggle = (props: ToogleShortProps) => {
  return (
    <div
      className={clsxm(
        "items-normal inline-flex",
        props.disabled ? "opacity-30" : "group"
      )}
    >
      <Switch
        className={clsxm(
          "relative inline-flex h-6 w-11 flex-shrink-0 items-center justify-center rounded-full transition-all",
          !props.disabled &&
            "cursor-pointer focus:outline-none focus-visible:shadow-outerBorder2 focus-visible:shadow-brand-100"
        )}
        checked={props.isEnabled}
        disabled={props.disabled}
        onChange={props.onChange}
      >
        <span className="sr-only">
          {props.label ? props.label : "Use toggle"}
        </span>
        <span
          aria-hidden="true"
          className={clsxm(
            props.isEnabled
              ? "bg-black-900 group-hover:bg-black-600 group-focus:bg-black-900 group-active:bg-black-500"
              : "bg-gray-100 group-hover:bg-gray-150 group-focus:bg-gray-100 group-active:bg-gray-200",
            "absolute inset-0 rounded-full transition"
          )}
        />
        <span
          aria-hidden="true"
          className={clsxm(
            props.isEnabled ? "translate-x-6" : "translate-x-1",
            "absolute left-0 inline-block h-4 w-4 transform rounded-full bg-white-900 shadow-sm ring-0 transition"
          )}
        />
      </Switch>
      {(props.label !== undefined || props.description !== undefined) && (
        <div className="flex flex-col">
          {props.label !== undefined && (
            <div
              className={clsxm(
                "select-none pl-2 pb-0.5 text-base text-black-900 transition ",
                !props.disabled &&
                  "cursor-pointer focus:text-black-900 group-hover:text-black-600 group-active:text-black-500"
              )}
              onClick={props.disabled ? undefined : props.onChange}
            >
              {props.label}
            </div>
          )}
          {props.description !== undefined && (
            <div
              className={clsxm(
                "select-none pl-2 text-sm text-black-600 transition",
                !props.disabled &&
                  "cursor-pointer focus:text-black-600 group-hover:text-black-600 group-active:text-black-500"
              )}
              onClick={props.disabled ? undefined : props.onChange}
            >
              {props.description}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Toggle;
